import React from 'react';
import classes from './CalendarCellTemplate.module.scss';
import { CellTemplateProps, PostingPlanCellDataType } from '../../../../models/calendar';
import { DroppableTableCell } from '../DroppableTableCell';
import { DraggableTimeslotWrapper } from '../DraggableTimeslotWrapper';
import { formatHour } from 'helpers/timeFormatter';

export const CalendarCellTemplateView = (props: CellTemplateProps<PostingPlanCellDataType>): JSX.Element => {
  const { row, position, timeFormat } = props;
  const [hour, day] = position;
  const notDroppable = row === undefined;

  if (day === 0 && hour > 0 && notDroppable) {
    return (
      <td key={`${hour}-${day}-table-cell`} className={classes.AxisLabelCell}>
        <div className={classes.AxisLabelWrapper}>
          <div className={classes.AxisLabel}>{formatHour(timeFormat, hour)}</div>
        </div>
      </td>
    );
  }

  if (notDroppable) {
    return <td key={`${hour}-${day}-table-cell`} />;
  }

  const timeSlots = row?.map(timeslot => (
    <DraggableTimeslotWrapper key={timeslot.id} {...timeslot} position={position} />
  ));

  return (
    <DroppableTableCell position={position} dayStartOfWeek={props.dayStartOfWeek}>
      {timeSlots}
    </DroppableTableCell>
  );
};
